import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { AutocompleteRenderInputParams } from '@material-ui/lab';

import { AutoSuggestControlProps } from './AutoSuggestControl.interfaces';
import { ControlContainer } from 'app/components/ControlContainer';
import { DoneAdornmentForAutoSuggest } from 'app/components/DoneAdornmentForAutoSuggest';
import { useAutoSuggestControl } from 'app/shared/hooks/controls/useAutoSuggestControl';
import { AutoSuggestAutocomplete } from 'app/components/AutoSuggestAutocomplete';
import { useStyles } from './AutoSuggestControl.styles';

export default function AutoSuggestControl(props: AutoSuggestControlProps) {
  const classes = useStyles();
  const {
    disabled,
    helperText,
    input,
    label,
    placeholder,
    meta,
    subLabel,
    tooltip,
    width,
    isLoadingResult,
    autoComplete = 'given-name',
    disablePortal,
  } = props;

  const {
    autoHighlight,
    disableClearable,
    error,
    filterOptions,
    handleBlur,
    inputHandleChange,
    isValueCheckVisible,
    onClose,
    onFocus,
    onOpen,
    open,
    suggestions,
  } = useAutoSuggestControl(props);

  const Input = (params: AutocompleteRenderInputParams) => {
    return (
      <TextField
        {...params}
        id={input.name}
        label={subLabel ? `${label} - ${subLabel}` : label}
        placeholder={placeholder}
        name={input.name}
        margin="dense"
        variant="outlined"
        fullWidth
        onFocus={onFocus}
        onBlur={handleBlur}
        error={error}
        inputProps={{
          ...params.inputProps,
          autoComplete,
        }}
        InputProps={{
          ...params.InputProps,
          startAdornment: isValueCheckVisible && (
            <DoneAdornmentForAutoSuggest />
          ),
        }}
      />
    );
  };

  return (
    <FormControl fullWidth>
      <ControlContainer
        inputId={input.name}
        tooltip={tooltip}
        helperText={helperText}
        meta={meta}
        width={width}
      >
        <AutoSuggestAutocomplete
          options={suggestions}
          autoHighlight={autoHighlight}
          filterOptions={filterOptions}
          inputValue={input.value}
          onInputChange={inputHandleChange}
          open={open}
          onOpen={onOpen}
          onClose={onClose}
          disableClearable={disableClearable || isLoadingResult}
          disablePortal={disablePortal}
          renderInput={Input}
          disabled={disabled}
          classes={{
            autoCompleteInputRoot: classes.autoCompleteInputRoot,
          }}
        />
      </ControlContainer>
    </FormControl>
  );
}
